module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-nav"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.smallScreen),
      expression: "!smallScreen"
    }],
    staticClass: "app-nav-list"
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "app-router-link",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Compare Quarters")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/historical-view",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "app-router-link",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Historical View")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70bc70fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-nav/AppNav.vue
// module id = 550
// module chunks = 1